import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router';

import errorWarningIcon from '@/assets/ErrorWarning.svg';
import { Button } from '@/common/components/ui/button';

export const GlobalErrorBoundary = () => {
  const { t } = useTranslation();

  return (
    <main className="flex flex-col items-center justify-center h-screen gap-6">
      <img src={errorWarningIcon} alt="Error warning" className="w-24 h-24" />

      <div className="text-center space-y-2">
        <h1 className="text-xl font-semibold text-destructive">
          {t('errorBoundary.title')}
        </h1>
        <p className="text-sm text-destructive max-w-md">
          {t('errorBoundary.description')}
        </p>
      </div>

      <Button asChild variant="secondary" className="text-destructive">
        <RouterLink to="/" reloadDocument>
          {t('errorBoundary.returnHome')}
        </RouterLink>
      </Button>
    </main>
  );
};
